export const API_URL = process.env.REACT_APP_API_URL || '';

export const END_POINTS = {
  login: '/api/login/',
  changePassword: '/api/change-password/',
  logout: '/api/logout/',
  confirmPassword: '/api/password-reset-confirm/',
  resetPassword: '/api/password-reset/',
  createAccount: '/api/register/',
  verifyOtp: '/api/verify-otp/',
  profile: '/api/profile/',
  updateProfile: '/api/profile/update/',
  resendOtp: '/api/resend-otp/',
  resetConfirm: '/api/password-reset-confirm/',
  cms: '/api/cms/',
  faqs: '/api/faqs/',
  uploadMedia: 'api/upload-media/',
  generateDesign: '/api/designs/generate/',
  designs: '/api/designs/',
  deleteDesign: '/api/designs/',
  claimDesign: '/api/designs/',
  certificate: '/api/designs/certificate/',
  assets: '/api/assets/',

};

//free apis
export const EXTERNAL_END_POINTS = {
  weatherForecast: "https://api.open-meteo.com/v1/forecast",
  reverseGeocode: "https://nominatim.openstreetmap.org/reverse"
};
